document.addEventListener('DOMContentLoaded', function() {

    fetchCryptoData();

    const searchInput = document.querySelector('#dictionary-search-input');
    let debounceTimeout = null;

    searchInput.addEventListener('keyup', function() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            if (searchInput.value.length === 0 || searchInput.value.length >= 3) {
                fetchCryptoData(searchInput.value);
            }
        }, 200);
    });
}, false);

function fetchCryptoData(symbol, page = 1) {
    const param = symbol ? `symbol=${symbol}` : (page ? `page=${page}` : null);
    const urlPath = '/crypto-data';
    const url = param ? (urlPath + '?' + param) : urlPath;
    const pageDictionary = document.querySelector('.page-dictionary');
    const searchInput = pageDictionary.querySelector('#dictionary-search-input');
    const container = pageDictionary.querySelector('#crypto-data-container');

    container.innerHTML = `
                <div class="row border-bottom py-48 px-32 position-relative hover\\@bg-gray-200">
                    <div class="col-lg-6">
                        <h3 class="bg-gray-200 skeleton mr-80">&nbsp;</h3>
                    </div>
                    <div class="col-lg-6">
                        <p class="bg-gray-200 skeleton mb-4">&nbsp;</p>
                        <p class="bg-gray-200 skeleton mr-80">&nbsp;</p>
                    </div>
                </div>`;

    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(({count, data}) => {
            container.innerHTML = '';
            if (count === 0) {
                const infoElement = document.createElement('div');
                infoElement.classList.add('alert', 'alert-info');
                infoElement.innerHTML = `<div class="icon" aria-hidden="true"></div> ${searchInput.dataset.noresult}`;
                container.appendChild(infoElement);
            } else {
                data.forEach((item, index, arr) => {
                    const itemElement = document.createElement('div');
                    itemElement.classList.add('row', 'py-32', 'py-lg-48', 'px-16', 'px-lg-32', 'position-relative', 'hover@bg-gray-200');
                    if (index !== arr.length -1) {
                        itemElement.classList.add('border-bottom');
                    }

                    itemElement.innerHTML = `
                        <div class="col-md-6">
                            <h3 class="mr-40">${item.name}</h3>
                        </div>
                        <div class="col-md-6">
                            <p>${item.intro}</p>
                        </div>
                        <a href="${item.url}" class="stretched-link">
                            <i class="icon-chevron-right position-absolute top-0 right-0 mt-40 mr-16 d-md-none"></i>
                        </a>`;

                    container.appendChild(itemElement);
                });

                pageDictionary.scrollIntoView({behavior: 'smooth', block: 'start'});

                if (count > 1) {
                    buildPagination(page, count);
                }
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
}

function buildPagination(currentPage, totalPages) {
    const container = document.getElementById('crypto-data-container');
    const paginationContainer = document.createElement('nav');
    paginationContainer.setAttribute('aria-label', 'Page navigation example');
    paginationContainer.classList.add('pt-16');

    const paginationList = document.createElement('ul');
    paginationList.classList.add('pagination', 'justify-content-center');

    // Obliczenie zakresu stron
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 3);

    // Przycisk "Poprzednia"
    if (currentPage > 1) {
        const prevItem = document.createElement('li');
        prevItem.classList.add('page-item');
        const prevLink = document.createElement('a');
        prevLink.classList.add('page-link');
        prevLink.setAttribute('aria-label', 'Previous');
        prevLink.addEventListener('click', function () {
            fetchCryptoData(null, currentPage - 1);
        });
        prevItem.appendChild(prevLink);
        paginationList.appendChild(prevItem);
    }

    // Numery stron
    for (let i = startPage; i <= endPage; i++) {
        const pageItem = document.createElement('li');
        pageItem.classList.add('page-item');
        if (i === currentPage) {
            pageItem.classList.add('active');
        }
        const pageLink = document.createElement('a');
        pageLink.classList.add('page-link');
        pageLink.textContent = i;
        pageLink.setAttribute('data-page', i);
        pageLink.addEventListener('click', function () {
            fetchCryptoData(null, i);
        });
        pageItem.appendChild(pageLink);
        paginationList.appendChild(pageItem);
    }

    // Przycisk "Następna"
    if (currentPage < totalPages) {
        const nextItem = document.createElement('li');
        nextItem.classList.add('page-item');
        const nextLink = document.createElement('a');
        nextLink.classList.add('page-link');
        nextLink.setAttribute('aria-label', 'Next');
        nextLink.addEventListener('click', function () {
            fetchCryptoData(null, currentPage + 1);
        });
        nextItem.appendChild(nextLink);
        paginationList.appendChild(nextItem);
    }

    paginationContainer.appendChild(paginationList);
    container.appendChild(paginationContainer);
}
